const toSec = (s) => s.trim().split(":").reduce((acc, x) => acc * 60 + parseFloat(x.replace(",", ".")), 0);

export function parseVtt(text) {
  return text.replace(/\r/g, "").split(/\n{2,}/).map((block) => {
    const lines = block.split("\n");
    const i = lines.findIndex((l) => l.includes("-->"));
    if (i < 0) return null;
    const [a, b] = lines[i].split("-->");
    const body = lines.slice(i + 1).join("\n").replace(/<[^>]+>/g, "").replace(/\{\\[^}]*\}/g, "").trim();
    return body ? { start: toSec(a), end: toSec(b.trim().split(/\s+/)[0]), text: body } : null;
  }).filter(Boolean);
}
